import * as React from 'react';
import PropTypes from 'prop-types';
import { useState } from 'react';

const BOOKMARK_STORAGE_KEY = 'bookmarked-attachments';

const BookmarksContext = React.createContext({});

const BookmarksContextStateProvider = ({ children }) => {
  const [bookmarkedAttachments, setBookmarkedAttachments] = useState(JSON.parse(localStorage.getItem(BOOKMARK_STORAGE_KEY)) || {});

  const toggleBookmark = (attachment) => {
    if (bookmarkedAttachments[attachment.id] !== undefined) {
      delete bookmarkedAttachments[attachment.id];
    } else {
      bookmarkedAttachments[attachment.id] = attachment;
    }
    localStorage.setItem(BOOKMARK_STORAGE_KEY, JSON.stringify(bookmarkedAttachments));
    setBookmarkedAttachments({ ...bookmarkedAttachments });
  };

  return (
    <BookmarksContext.Provider
      value={{
        bookmarkedAttachments,
        setBookmarkedAttachments,
        toggleBookmark,
      }}
    >
      {children}
    </BookmarksContext.Provider>
  );
};

BookmarksContextStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export {
  BookmarksContext,
  BookmarksContextStateProvider,
};
